export default __webpack_public_path__ + "static/media/Maxdol-30-mg-IM-IV-eng.a914c01e.jpg";